import {AuthState} from "../reducers/authReducer";

export const getInitialAuthState = () => {
    const initialAuthState: AuthState = {
        IsLoggedIn: localStorage.getItem('caruzToken') != null,
        Username: localStorage.getItem('caruzUsername') || ''
    }

    return initialAuthState
};